import { c as j } from "./@contentful-cca97bae.js";
var D = { exports: {} };
(function(C) {
  (function(l, u) {
    C.exports ? C.exports = u() : l.parseSrcset = u();
  })(j, function() {
    return function(l) {
      function u(r) {
        return r === " " || // space
        r === "	" || // horizontal tab
        r === `
` || // new line
        r === "\f" || // form feed
        r === "\r";
      }
      function S(r) {
        var s, i = r.exec(l.substring(o));
        if (i)
          return s = i[0], o += s.length, s;
      }
      for (var E = l.length, I = /^[ \t\n\r\u000c]+/, N = /^[, \t\n\r\u000c]+/, $ = /^[^ \t\n\r\u000c]+/, A = /[,]+$/, L = /^\d+$/, F = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, p, a, e, n, t, o = 0, b = []; ; ) {
        if (S(N), o >= E)
          return b;
        p = S($), a = [], p.slice(-1) === "," ? (p = p.replace(A, ""), g()) : V();
      }
      function V() {
        for (S(I), e = "", n = "in descriptor"; ; ) {
          if (t = l.charAt(o), n === "in descriptor")
            if (u(t))
              e && (a.push(e), e = "", n = "after descriptor");
            else if (t === ",") {
              o += 1, e && a.push(e), g();
              return;
            } else if (t === "(")
              e = e + t, n = "in parens";
            else if (t === "") {
              e && a.push(e), g();
              return;
            } else
              e = e + t;
          else if (n === "in parens")
            if (t === ")")
              e = e + t, n = "in descriptor";
            else if (t === "") {
              a.push(e), g();
              return;
            } else
              e = e + t;
          else if (n === "after descriptor" && !u(t))
            if (t === "") {
              g();
              return;
            } else
              n = "in descriptor", o -= 1;
          o += 1;
        }
      }
      function g() {
        var r = !1, s, i, h, m, d = {}, f, v, c, x, w;
        for (m = 0; m < a.length; m++)
          f = a[m], v = f[f.length - 1], c = f.substring(0, f.length - 1), x = parseInt(c, 10), w = parseFloat(c), L.test(c) && v === "w" ? ((s || i) && (r = !0), x === 0 ? r = !0 : s = x) : F.test(c) && v === "x" ? ((s || i || h) && (r = !0), w < 0 ? r = !0 : i = w) : L.test(c) && v === "h" ? ((h || i) && (r = !0), x === 0 ? r = !0 : h = x) : r = !0;
        r ? console && console.log && console.log("Invalid srcset descriptor found in '" + l + "' at '" + f + "'.") : (d.url = p, s && (d.w = s), i && (d.d = i), h && (d.h = h), b.push(d));
      }
    };
  });
})(D);
var z = D.exports;
export {
  z as p
};
